import { useCallback, useMemo } from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

export function useGetPetitionShareTrackingData(): ShareActionsOptions<ShareChannel>['getTrackingData'] {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { ownPetition },
	} = usePetitionDetailsPageUserData();

	const commonTrackingData = useMemo(
		() => ({
			petition_id: `petition_${id}`,
			context: 'petition_show',
			view_context: 'petition_show',
			own_petition: ownPetition,
		}),
		[id, ownPetition],
	);
	return useCallback((_channel: ShareChannel) => commonTrackingData, [commonTrackingData]);
}
